import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <g transform="translate(5.000000, -1.000000)">
          <g transform="scale(1.5)">
            <path
              d="M 35.6887 42 h -6.3633 l -8.0684 -11.1445 q -0.8965 0.0352 -1.459 0.0352 q -0.2285 0 -0.4922 0 q -0.2637 -0.0176 -0.5449 -0.0352 v 6.9258 q 0 2.25 0.4922 2.7949 q 0.668 0.7734 2.0039 0.7734 h 0.9316 V 42 H 11.9758 v -0.6504 h 0.8965 q 1.5117 0 2.1621 -0.9844 q 0.3691 -0.5449 0.3691 -2.584 v -15.3984 q 0 -2.25 -0.4922 -2.7949 q -0.6855 -0.7734 -2.0391 -0.7734 h -0.8965 v -0.6504 h 8.6836 q 3.7969 0 5.5898 0.5625 q 1.8105 0.5449 3.0586 2.0391 q 1.2656 1.4766 1.2656 3.5332 q 0 2.1973 -1.4414 3.8145 q -1.4238 1.6172 -4.4297 2.2852 l 4.9219 6.8379 q 1.6875 2.3555 2.9004 3.1289 q 1.2129 0.7734 3.1641 0.9844 z M 18.7609 29.748 q 0.334 0 0.5801 0.0176 q 0.2461 0 0.4043 0 q 3.4102 0 5.1328 -1.4766 q 1.7402 -1.4766 1.7402 -3.7617 q 0 -2.2324 -1.4063 -3.6211 Q 23.8234 19.5 21.5207 19.5 q -1.0195 0 -2.7598 0.334 z"
              fill="currentColor"
            />
          </g>
        </g>
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
